// src/components/Voice.js

const Voice = () => {
  return (
    <div>
      <h1>Voice</h1>
      {/* Voice content goes here */}
    </div>
  );
};

export default Voice;
